export const useHrDropdownOptions = () => {

    const trainerStatusOption = [
        {
            id: 1,
            label: "Created",
            value: "Created",
        },
        {
            id: 2,
            label: "Approved by HR",
            value: "Approved by HR",
        },
        {
            id: 3,
            label: "Accepted by Trainer",
            value: "Accepted by Trainer",
        },
        {
            id: 4,
            label: "HR Rejected",
            value: "HR Rejected",
        },
        {
            id: 5,
            label: "Rejected by Trainer",
            value: "Rejected by Trainer",
        },
    ];



    return {
        trainerStatus: {
            options: trainerStatusOption,

        }

    };
};
